import { MUELLIF_GUNCELLE_LISTESI } from "../constants/requestUrls";

import { postRequest } from "../request";

const MuellifGuncelleListesi = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: MUELLIF_GUNCELLE_LISTESI, data });
}

export default MuellifGuncelleListesi;